import React from 'react';
import { CompassIcon, SearchIcon, PenToolIcon, PaletteIcon, LayersIcon, BookOpenIcon, FolderOpenIcon } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
const features = [{
  icon: CompassIcon,
  text: 'Clear brand & creative direction'
}, {
  icon: SearchIcon,
  text: 'Foundational brand deep dive'
}, {
  icon: PenToolIcon,
  text: 'Logo concepts refined to one confident mark'
}, {
  icon: PaletteIcon,
  text: 'Colour palette & typography direction'
}, {
  icon: LayersIcon,
  text: 'Core brand assets'
}, {
  icon: BookOpenIcon,
  text: 'Simple brand guidelines'
}, {
  icon: FolderOpenIcon,
  text: 'Organised files (web, digital, print)'
}];
export function WhatsIncluded() {
  return <section id="included" className="py-24 px-6 bg-offwhite" data-id="element-292">
      <div className="max-w-7xl mx-auto" data-id="element-293">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-294">
          <div className="lg:col-span-5" data-id="element-295">
            <ScrollReveal data-id="element-296">
              <span className="text-accent font-bold tracking-wider text-sm" data-id="element-297">
                Deliverables
              </span>
              <h2 className="text-4xl md:text-5xl font-extrabold text-navy mt-2 mb-8" data-id="element-298">
                What's included
              </h2>

              <div className="bg-navy text-white p-8 rounded-2xl shadow-xl relative overflow-hidden" data-id="element-299">
                <div className="absolute top-0 right-0 w-32 h-32 bg-accent/20 rounded-full -mr-16 -mt-16 blur-2xl" data-id="element-300" />
                <h3 className="text-2xl font-bold leading-tight relative z-10" data-id="element-301">
                  4-week design sprint for a clear, usable brand and logo.
                </h3>
                <p className="mt-4 text-gray-300 relative z-10" data-id="element-302">
                  Everything you need to launch with confidence, delivered in a
                  streamlined process.
                </p>
              </div>
            </ScrollReveal>
          </div>

          <div className="lg:col-span-7" data-id="element-303">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-304">
              {features.map((feature, index) => <ScrollReveal key={index} delay={index * 0.1} data-id="element-305">
                  <div className="flex items-start p-6 bg-white rounded-xl shadow-sm border border-transparent" data-id="element-306">
                    <div className="bg-offwhite p-3 rounded-lg mr-4" data-id="element-307">
                      <feature.icon className="w-6 h-6 text-accent" data-id="element-308" />
                    </div>
                    <span className="text-navy font-medium pt-2" data-id="element-309">
                      {feature.text}
                    </span>
                  </div>
                </ScrollReveal>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}